export default "__VITE_ASSET__hYOwNPKf__"